import { isNull, isNullOrUndefined } from "util";
import * as Utils from './utilSvc';
import * as Const from './const';
import * as DbUtils from './DbSvc';
import firebase from "firebase/app";
import 'firebase/firestore';
import 'firebase/functions';


const Day = 24*60*60*1000;

const checkIfWikipedia = (result) => {
    let link = result.link;
    let title = result.title;
    if(!isNullOrUndefined(link) && !isNullOrUndefined(title)){
        if(link.includes('wikipedia') && title.includes('Wikipedia'))
            return true;
    }
    return false;
}

const checkIfWikipediaInList = (results, output) => {
    for(let i=0; !isNullOrUndefined(results) && i<results.length;
    i++)
    {
        let currResult = results[i];
        if(checkIfWikipedia(currResult)){
            output.push({
                'link': currResult.link,
                'title': currResult.title
            });
        }
        if('sitelinks' in currResult){
            for(var x in currResult['sitelinks']){
                checkIfWikipediaInList(currResult['sitelinks'][x])
            }
        }
    }
}

export const getWikipediaLinks = (googleSearchRes) => {
    let output = [];
    if('organic_results' in googleSearchRes){
        let results = googleSearchRes['organic_results'];
        checkIfWikipediaInList(results,output);    
    }
    return output;
}

export const getFirstWord = (str) => {
    let firstWord = '';
    if(!isNullOrUndefined(str)){
        firstWord = str.replace(/ .*/,'');
    } 
    return firstWord
}
 
export const getGoogleAnswer = (googleSearchRes, keyWord) => {

    let output = {};
    if('answer_box' in googleSearchRes){
        let answer_box = googleSearchRes['answer_box'];

        if("answer" in answer_box){
            //Direct answer
            output['data'] = Utils.capitalizeFirstLetter(answer_box["answer"]);
        }
        else if('snippet' in answer_box){
            output['data'] = Utils.capitalizeFirstLetter(answer_box["snippet"]);
            output['isSnippet'] = true
        }
        else{

            //Special cases
            // console.log(answer_box);
            
            //Annual revenue 
            if('contents' in answer_box && 'table' in answer_box['contents']){
                //Revenue table here
                let table = answer_box['contents']['table'];
                // console.log(table);
                let header = null;
                if(table.length>0){
                    header = table[0];
                }

                let revenueIndex = -1, yearIndex = -1;
                for(let i=0;!isNullOrUndefined(header) && i<header.length; i++){
                    let headerStr = header[i];
                    headerStr = headerStr.toLowerCase();
                    if(headerStr.includes('revenue')){
                        revenueIndex = i;
                    }
                    else if(headerStr.includes('year')){
                        yearIndex = i;
                    }
                }
                // console.log(revenueIndex,yearIndex);
                if(yearIndex>=0 && revenueIndex>=0){
                    let ans = "";
                    let currYear = "0000"; 
                    for(let i=1; i<table.length; i++){
                        if(parseInt(table[i][yearIndex]) > parseInt(currYear)){
                            currYear = table[i][yearIndex];
                            ans = table[i][revenueIndex] + " (" + currYear + ")";
                        }
                    }
                    // console.log(currYear, ans);
                    if(ans!=""){
                        output['data'] = ans;
                    }
                }
            }
        }

        if("link" in answer_box){
            output['link'] = Utils.capitalizeFirstLetter(answer_box['link']);
        }
    }
    return output;
}

export const getFundingFromGoogleSearch = (googleList, company) => {

    // console.log(googleList);
    
    let final = [];
    if('organic_results' in googleList){
        let listResults = googleList['organic_results'];
        let companyWords = getCompanyWords(company); 
        let companySubstrings = createLinearSubstringsForCompany(companyWords);
        let linksAdded = {};
        for(let i=0; !isNullOrUndefined(listResults) && i<listResults.length; i++){
            for(let j=companySubstrings.length-1; j>=0; j--){
                let currCompanyStr = companySubstrings[j];
                let newData = {}, data = listResults[i];
                let canAddData = true;
                if('date' in data){
                    newData['date'] = data.date;
                }
                if('link' in data){
                    newData['link'] = data.link;
                }
                if('title' in data){
                    newData['title'] = data.title;
                }
                if('snippet' in data){
                    newData['snippet'] = data.snippet;
                }
                newData['titleCompanyScore'] = j;

                if(isNullOrUndefined(data.title) || isNullOrUndefined(data.date) || isNullOrUndefined(data.link) || 
                data.link in linksAdded){
                    canAddData = false;
                }
                if(!(newData.title.toLowerCase().includes('fund') || newData.title.toLowerCase().includes('raise')
                || newData.title.toLowerCase().includes('invest'))
                ||
                (!(newData.title.toLowerCase().includes(currCompanyStr.toLowerCase())))
                ){
                    //String does not contain fund OR invest OR raise. 
                    // String does not contain company name
                    canAddData = false;
                }
                
                if(canAddData){
                    final.push(newData);
                    linksAdded[newData.link] = '';
                }
            }
        }
    }

    //Sorting based on scores
    final.sort(function (a,b){
        return b.titleCompanyScore - a.titleCompanyScore;
    })
    
    return final;
}

const getNextWordIndex = (str, index) => {
    if(isNullOrUndefined(str))
        return -1;

    //traverse current word
    while(index<str.length && str[index]!=' ')
        index++;
    
    //traverse spaces
    while(index<str.length && str[index]==' ')
        index++;

    return index;
}

export const getNlpGoogleAnswer = (snippetKeys, nlpMissingKeys, snippetText) => {
    let finalAns = {};
    if(!isNullOrUndefined(nlpMissingKeys) && nlpMissingKeys.length>0){
        for(let key in snippetKeys){
            if(key == 'industry'){
                let ans = "", secondaryAns = "";
                for(let i=0; i<nlpMissingKeys.length; i++){
                    let name = nlpMissingKeys[i].name.toLowerCase();
                    if(name.includes("industry") && name.length>"industry".length){
                        if(name.indexOf("industry")+"industry".length == name.length){
                            ans = nlpMissingKeys[i].name;
                        }
                    }
                    if(name.includes("company") && name.length>"company".length){
                        if(name.indexOf("company")+"company".length == name.length){
                            secondaryAns = nlpMissingKeys[i].name;
                        }
                    }
                    if(name.includes("firm") && name.length>"firm".length){
                        if(name.indexOf("firm")+"firm".length == name.length){
                            secondaryAns = nlpMissingKeys[i].name;
                        }
                    }
                }
                if(ans == "" && secondaryAns != "")
                    ans = secondaryAns;
                if(ans != "")
                    finalAns[key] = ans;
            }
            else if(key == 'employees'){
                let ans = "";
                let start = snippetKeys[key].start;
                let end = snippetKeys[key].end;
                let numbersIndex= [], employeeIndexMap = {};

                for(let i=0; i<nlpMissingKeys.length; i++){
                    let name = nlpMissingKeys[i].name.toLowerCase();
                    let type = nlpMissingKeys[i].type.toLowerCase();
                    if(name.includes("employee")){
                        if(nlpMissingKeys[i].mentions){
                            for(let j=0; j< nlpMissingKeys[i].mentions.length; j++){
                                let mention = nlpMissingKeys[i].mentions[j];
                                if(mention.beginOffset >= start && mention.beginOffset <= end){
                                    employeeIndexMap[mention.beginOffset] = '';
                                }
                            }
                        }
                    }
                    if(type == "number"){
                        if(nlpMissingKeys[i].mentions){
                            for(let j=0; j< nlpMissingKeys[i].mentions.length; j++){
                                let mention = nlpMissingKeys[i].mentions[j];
                                if(mention.beginOffset >= start && mention.beginOffset <= end){
                                    numbersIndex.push({
                                        index: mention.beginOffset,
                                        value: mention.text
                                    });
                                }
                            }
                        }
                    }                   
                }
                // nIndex -> nextWord = eIndex 
                // console.log(employeeIndexMap, numbersIndex);

                for(let i=0; i<numbersIndex.length; i++){
                    let index = numbersIndex[i].index;
                    let numText = numbersIndex[i].value;
                    
                    let nextWordIndex = getNextWordIndex(snippetText, index);
                    if(nextWordIndex in employeeIndexMap){
                        ans = numText + " employees";
                        break;
                    }
                }
                if(ans != "")
                    finalAns[key] = ans;
            }
            if(key == 'revenue'){
                let ans = "";
                let start = snippetKeys[key].start;
                let end = snippetKeys[key].end;

                let priceVals = {};
                for(let i=0; i<nlpMissingKeys.length; i++){
                    let name = nlpMissingKeys[i].name.toLowerCase();
                    let type = nlpMissingKeys[i].type.toLowerCase();

                    if(type=="price"){
                        if(nlpMissingKeys[i].mentions){
                            for(let j=0; j< nlpMissingKeys[i].mentions.length; j++){
                                let mention = nlpMissingKeys[i].mentions[j];
                                if(mention.beginOffset >= start && mention.beginOffset <= end){
                                    priceVals[name.trim()] = mention.beginOffset;
                                    break;
                                }
                            }
                        }
                    }
                }
                
                // console.log(priceVals);
                if(Object.keys(priceVals).length == 1){
                    for(let key in priceVals){
                        ans = key;
                    }
                }
                if(ans != "")
                    finalAns[key] = ans;
            }
        }
    }

    return finalAns;
}

export const getCompanyWords = (str) => {
    //Assumes string is single line
    let wordArr = []
    if(isNullOrUndefined(str))
        return wordArr;

    let currWord = "";
    for(let i=0; i<str.length; i++){
        if(str[i]==" "){
            if(currWord.length>0)
                wordArr.push(currWord);
            currWord="";
        }
        else{
            currWord += str[i];
        }
    }
    if(currWord.length>0)
        wordArr.push(currWord);
    return wordArr;
}

const getAllSubstring = (str, substr) => {
    str = str.toLowerCase();
    substr = substr.toLowerCase();

    var searchKeyword = substr;

    // console.log("*",substr, str);
    
    var startingIndices = [];
    
    var indexOccurence = str.indexOf(searchKeyword, 0);
    
    while(indexOccurence >= 0) {
        // console.log(indexOccurence);
        startingIndices.push(indexOccurence);    
        indexOccurence = str.indexOf(searchKeyword, indexOccurence + 1);
    }
    return startingIndices;
}

export const createLinearSubstringsForCompany = (companyWords) =>{
    let subStr = "", ans = [];
    for(let i=0; !isNullOrUndefined(companyWords) && i<companyWords.length; i++){
        subStr += " " + companyWords[i];
        ans.push(subStr.trim());
    }
    return ans;
}

export const getIndicesOfCompanyNamesInString = (wordStr, company) => {
    if(!isNullOrUndefined(wordStr) && !isNullOrUndefined(company)){
        let companyWords = getCompanyWords(company);
        let companySubstrings = createLinearSubstringsForCompany(companyWords)
        // console.log("Company words and substrings:")
        // console.log(companyWords, companySubstrings);

        let ans = {};
        for(let i=0; i<companySubstrings.length; i++){
            let out = getAllSubstring(wordStr, companySubstrings[i]);
            // console.log(companySubstrings[i], out);
            
            for(let j=0; j<out.length; j++){
                if(out[j]>=0){
                    let end = out[j] + companySubstrings[i].length - 1;
                    if(!(out[j] in ans)){
                        ans[out[j]] = end;
                    }
                    ans[out[j]] = Math.max(ans[out[j]],end);

                }
            }           
        }
        // console.log(ans);
        return ans;
    }
    return {};
}

export const getUrlBase = (url) => {
    if(isNullOrUndefined(url))
        return null;
    
    var pathArray = url.split( '/' );
    let ans = null;
    if(pathArray.length>2){
        var protocol = pathArray[0];
        ans = pathArray[2];
    }
    return ans;    
}

export const getUrlFullBase = (url) => {
    if(isNullOrUndefined(url))
        return null;
    
    var pathArray = url.split( '/' );
    let ans = null;
    // console.log(pathArray);
    if(pathArray.length>=2){
        ans = pathArray[0] +"/" + pathArray[1] + "/" + pathArray[2];
    }
    return ans;    
}

export const getWebsiteFromGoogleSearchResults = (googleSearchResult, company) => {
    if(isNullOrUndefined(googleSearchResult) || isNullOrUndefined(company) || company.trim().length==0)
        return null;
    
    let companyWords = getCompanyWords(company);
    for(let i=0; !isNullOrUndefined(companyWords) && i<companyWords.length; i++){
        companyWords[i] = companyWords[i].toLowerCase();
    }
    // console.log(companyWords);
    // console.log(googleSearchResult);

    let googleSearchArr = [];
    if('answer_box' in googleSearchResult){
        googleSearchArr.push(googleSearchResult['answer_box']);
    }

    if('organic_results' in googleSearchResult){
        let organic_results = googleSearchResult['organic_results'];
        for(let i=0; i<4 && i<organic_results.length; i++){
            googleSearchArr.push(organic_results[i]);
        }
    }

    let ans = null;
    for(let i=0; i<googleSearchArr.length; i++){
        if('link' in googleSearchArr[i]){
            let link = googleSearchArr[i].link.toLowerCase();
            link = getUrlFullBase(link);
            //console.log(link);
            let count_link = 0;
            for(let j=0; !isNullOrUndefined(link) && j<companyWords.length; j++){
                if(link.includes(companyWords[j])){
                    count_link++;
                }
            }

            // console.log(link, count_link,"Count_link");

            if(count_link>0){
                if('title' in googleSearchArr[i]){
                    let title = googleSearchArr[i].title.toLowerCase();
                    let count_title = 0;
                    for(let j=0; j<companyWords.length; j++){
                        if(title.includes(companyWords[j])){
                            count_title++;
                        }
                    }
                    // console.log(title,count_title,"Count_title");
                    if(count_title>0){
                        ans = link;
                    }
                }
            }
        }
        if(!isNullOrUndefined(ans))
            break;
    }
    return ans;
}

export const sortParasScores = (paraArr, maxParas) => {

    if(isNullOrUndefined(paraArr) || paraArr.length==0)
        return [];

    //add Index field
    for(let i=0; i<paraArr.length; i++){
        paraArr[i]['index'] = i;
        if(!('score' in paraArr[i])){
            paraArr[i]['score']=0;
        }
    }

    //sort on score
    paraArr.sort((e1, e2) => {     
        if(e1.score == e2.score)
            return e1.index - e2.index;   
        return e2.score - e1.score;
    })

    if(isNullOrUndefined(maxParas)){
        maxParas = paraArr.length;
    }
    let newParaArr = [];
    for(let i=0; i<paraArr.length && i<maxParas; i++){
        if(paraArr[i].score>0)
            newParaArr.push(paraArr[i]);
    } 
    
    paraArr = newParaArr;
    paraArr.sort((e1, e2) => {        
        return e1.index - e2.index;
    })

    //return
    return paraArr;
}

export const getAggregatedParaText = (paraArr, parasPerBlock) => {
    // parasPerBlock is number of paras taken together as a block

    let output = [];
    if(isNullOrUndefined(paraArr) || paraArr.length==0)
        return [""];
    if(isNullOrUndefined(parasPerBlock))
        parasPerBlock = paraArr.length;
    parasPerBlock = Math.max(1,parasPerBlock);

    let cnt = 0;
    let currStr = ""
    for(let i=0; i<paraArr.length ; i++){        
        if('text' in paraArr[i]){
            currStr += paraArr[i].text.trim();
            currStr += " ";
            cnt++;
        }
        cnt = cnt%parasPerBlock;
        if(cnt == 0){
            output.push(currStr);
            currStr = "";
        }
    }
    if(cnt>0){
        output.push(currStr);
        currStr = "";
    }
    return output
}

export const filterCyberNewsResultsForIndustry = async(results, industry) => {
    // console.log(results);
    if(isNullOrUndefined(results) || isNullOrUndefined(industry))    
        return [];

    let finalAns = [];
    
    for(let i=0; i<results.length; i++){
        if('title' in results[i]){   
            finalAns.push(results[i]);
        }
    }

    // console.log(finalAns);

    //Bucketing
    let buckets = {
        'cyberIncidents':[], 'cyberPartner':[], 'cyber_other':[]
    }
    for(let i=0; i<finalAns.length; i++){
        let othersFlag = true;
        let currTitle = finalAns[i].title.toLowerCase();

        let cyberIncidentKeyWords = Const.cyberNewsKeywordsForUI['all'];
        for(let j=0; j<cyberIncidentKeyWords.length; j++){
            if(currTitle.includes(cyberIncidentKeyWords[j])){
                buckets['cyberIncidents'].push(finalAns[i]);
                othersFlag = false;
            }
        }
        if(othersFlag && (currTitle.includes('partner') || currTitle.includes('team'))){
            // buckets['cyberPartner'].push(finalAns[i]);
            othersFlag = false;
        }
        if(othersFlag && (currTitle.includes('cyber') || currTitle.includes('digital'))){
            // buckets['cyber_other'].push(finalAns[i]);
            othersFlag = false;
        }
        if(othersFlag){
        //    buckets.cyber_other.push(finalAns[i]);
        }
    }

    for(let key in buckets){
        if(buckets[key].length == 0){
            delete buckets[key];
        }
    }
    // console.log(buckets);

    // console.log(topNewsOutput);
    
    return buckets;
}

export const filterCyberNewsResults = async(results, company) => {
    // console.log(results);
    if(isNullOrUndefined(results) || isNullOrUndefined(company))    
        return [];
   
    let companyWords = company.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g,"").split(/\s+/); 
    let companySubstrings = createLinearSubstringsForCompany(companyWords);
    // console.log(companyWords, companySubstrings)
    let finalAns = [];
    /* 
    for(let i=0; i<results.length; i++){
        // console.log(results[i].title.toLowerCase(), company.toLowerCase());
        // Old way
        for(let j=0; j<companySubstrings.length; j++){
            let currCompanyStr = companySubstrings[j];
            if('title' in results[i] && j>= companySubstrings.length-2 &&
            results[i].title.includes(currCompanyStr)){                
                finalAns.push(results[i]);
            }
        }              
    }
    */

   //Make the first word capital with all others small
   if(companyWords.length>0){
       companyWords[0] = companyWords[0].charAt(0) + companyWords[0].slice(1).toLowerCase();
   }

    //New way, string match
    let companyWordsHash = {};
    for(let j=0; j<companyWords.length; j++){
        companyWordsHash[companyWords[j]] = j;
    }
    for(let i=0; i<results.length; i++){
        if('title' in results[i]){
            let titleText = results[i]['title'];
            let titleWords = titleText.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g,"").split(/\s+/);
            let currIndex = -1;
            for(let j=0; j<titleWords.length; j++){
                let currTitleWord = titleWords[j];
                if(titleWords[j].length>1){
                    currTitleWord = titleWords[j].charAt(0) + titleWords[j].slice(1).toLowerCase();
                }
                if(currTitleWord in companyWordsHash){
                    let wordIndex = companyWordsHash[currTitleWord];
                    if(wordIndex == currIndex+1){
                        currIndex = wordIndex;
                    }
                }
            }
            // console.log(currIndex, titleWords, companyWordsHash);
            if(currIndex>=0){
                finalAns.push(results[i]);
            }
        }
    }

    // console.log(finalAns);

    //Bucketing
    let buckets = {
        'cyberIncidents':[], 'cyberPartner':[], 'cyber_other':[]
    }
    for(let i=0; i<finalAns.length; i++){
        let othersFlag = true;
        let currTitle = finalAns[i].title.toLowerCase();

        let cyberIncidentKeyWords = Const.cyberNewsKeywordsForUI['all'];
        for(let j=0; j<cyberIncidentKeyWords.length; j++){
            if(currTitle.includes(cyberIncidentKeyWords[j])){
                buckets['cyberIncidents'].push(finalAns[i]);
                othersFlag = false;
            }
        }
        if(othersFlag && (currTitle.includes('partner') || currTitle.includes('team'))){
            // buckets['cyberPartner'].push(finalAns[i]);
            othersFlag = false;
        }
        if(othersFlag && (currTitle.includes('cyber') || currTitle.includes('digital'))){
            // buckets['cyber_other'].push(finalAns[i]);
            othersFlag = false;
        }
        if(othersFlag){
        //    buckets.cyber_other.push(finalAns[i]);
        }
    }

    for(let key in buckets){
        if(buckets[key].length == 0){
            delete buckets[key];
        }
    }
    // console.log(buckets);

    // console.log(topNewsOutput);
    
    return buckets;
}

export const saveSecInDbApiCall = async(stock, type) => {
    if(isNullOrUndefined(stock))
        return [];

    if(isNullOrUndefined(type))
        type = "10-Q";

    try{

        let shouldGet = false;
        let query = firebase.firestore().collection("Data").doc(type).collection("metadata").where("stock","==",stock).orderBy("dateTime","desc").limit(1);
        let queryOutput = await query.get();
        let docs = queryOutput.docs;
        if(docs.length == 0)
            shouldGet = true;
        // console.log(docs);
        for(let i=0; i<docs.length; i++){
            let doc = docs[i];
            
            if(!doc.exists){
                shouldGet = true;
            }
            else{
                let ts = doc.data()['dateTime'];
                if(Math.abs(ts-Date.now())>6*30*Day){
                    shouldGet = true
                }
            }
        }
        if(shouldGet){
            const endpoint = 'https://us-central1-flowpro-9e1c6.cloudfunctions.net/saveSECDataWrapper';

            let res = await fetch(endpoint, 
                { 
                    method: 'POST', 
                    body: JSON.stringify({'stock': stock, 'type':type}),
                    headers: new Headers({'content-type': 'application/json'})
                }
            ).catch((err)=>{console.log(err)}); 
        }
    }
    catch(e){
        console.log(e);
    }
}

export const secDbApiCall = async(stock, type, section, filters) => {
    if(isNullOrUndefined(stock))
        return [];
    
    if(isNullOrUndefined(type))
        type = "10-Q";
    
    if(isNullOrUndefined(section))
        section = 'risk factors';
    
    if(isNullOrUndefined(filters)){
        filters = [];
    }

    const endpoint = 'https://us-central1-flowpro-9e1c6.cloudfunctions.net/getSECdataFromDb';
        let output = [];
        // console.log(endpoint);
        // console.log(searchQuery);

        // console.log("here1",stock,type,section,filters);
        let res = await fetch(endpoint, 
            { 
                method: 'POST', 
                body: JSON.stringify({'stock': stock, 'type':type, 'section':section, 'filters':filters}),
                headers: new Headers({'content-type': 'application/json'})
            }
        ).catch((err)=>{console.log(err)}); 

        // console.log("here2",res);
        if(!isNullOrUndefined(res)){
            let resJson = await res.json();
            output = resJson;        
            // console.log(output);    
        }
        return output

}


export const getSecArraySummary = async(array, filters) => {
    
    if(isNullOrUndefined(array) || array.length==0)
        return [];
    
    let summaryPromise = [];
    let allParas = [];
    for(let i=0; i<array.length; i++){
        let str = array[i].text;
        str = str.replace(/[^\x00-\x7F]/g, "");
        str = str.trim();
        allParas.push(str);
    }

    let summaries = customSummaryCall(allParas, filters, 4);
    return summaries;
}

export const customSummaryCall = async(textArr, filters, limit) => {

    if(isNullOrUndefined(textArr) || textArr.length==0 || isNullOrUndefined(filters))
        return [];
    if(isNullOrUndefined(limit))
        limit = 5;

    // console.log(textArr);
    // console.log(filters);

    let output = [];
    const endpoint = 'https://us-central1-flowpro-9e1c6.cloudfunctions.net/getSummaryUsingSentenceKeywords';
    let res = await fetch(endpoint, 
        { 
            method: 'POST', 
            body: JSON.stringify({'textArr': textArr, 'wordList':filters, "limit":limit}),
            headers: new Headers({'content-type': 'application/json'})
        }
    ).catch((err)=>{console.log(err)}); 

    if(!isNullOrUndefined(res)){
        let resJson = await res.json();
        output = resJson;
    }
    return output;
}


export const openApiSummaryCall = async(text, quality, wordLimit) => {
    if(isNullOrUndefined(wordLimit))
        wordLimit = 40;
    if(isNullOrUndefined(quality))
        quality = "medium";
    if(isNullOrUndefined(text) || text.trim().length==0)
        return "";
    
    let output = {};
    const endpoint = 'https://us-central1-flowpro-9e1c6.cloudfunctions.net/summarizeTextUsingOpenAI';
    let res = await fetch(endpoint, 
        { 
            method: 'POST', 
            body: JSON.stringify({'text': text, 'length':wordLimit, "quality":quality}),
            headers: new Headers({'content-type': 'application/json'})
        }
    ).catch((err)=>{console.log(err)}); 

    if(!isNullOrUndefined(res)){
        let resJson = await res.json();
        if('choices' in resJson && resJson['choices'].length>0){
            output = resJson['choices'][0]['text']
        }
    } 
    return output;
}

export const parseCompetitorsSearchOutput = async(response, company) => {
    if(isNullOrUndefined(response) || !('answer_box' in response)){
        return null;
    }
    let answer = response['answer_box'];
    let output = null;
    let answerList = [];
    let link = null;
    if('link' in answer){
        link = answer['link'];
    }

    if('list' in answer){
        // list format: Eg: ZoomInfo
        for(let i=0; !isNullOrUndefined(answer['list']) && i<answer['list'].length;i++){
            let listText = answer['list'][i];
            let listTextSentences = Utils.getSentences(listText);
            if(listTextSentences.length>0 && listTextSentences[0].trim().length>0){
                let sentenceText = listTextSentences[0].trim();
                let unwantedChars = ",. ?!"
                let len = sentenceText.length;
                for(let j=sentenceText.length-1; j>=0; j--){
                    if(unwantedChars.includes(sentenceText[j])){
                        len--
                    }
                    else
                        break;
                }
                sentenceText = sentenceText.substr(0,len);

                //further parse the word itself
                let last_index = 0;
                while(last_index<sentenceText.length){
                    let currChar = sentenceText.charAt(last_index);
                    let isPermit = false;
                    if((currChar>='a' && currChar<='z') || (currChar>='A' && currChar<='Z') || 
                    (currChar>='0' && currChar<='9') || currChar==' '){
                        isPermit = true;
                    }
                    if(currChar=='.'){
                        //Fullstop, check previous char if it was capital letter or not
                        if(last_index>0){
                            let prevChar = sentenceText.charAt(last_index-1);
                            if(prevChar>='A' && prevChar<='Z'){
                                //Check if the previous char before that is either a '.' or a ' '
                                if(last_index==1)
                                    isPermit = true;
                                if(last_index>1){
                                    let olderChar = sentenceText.charAt(last_index-2);
                                    if(olderChar=='.' || olderChar==' ')
                                        isPermit = true;
                                }
                            }
                        }
                    }
                    // console.log(currChar, isPermit);
                    if(isPermit)
                        last_index++;
                    else
                        break;
                }
                sentenceText = sentenceText.substr(0,last_index);
                sentenceText = sentenceText.trim();
                // console.log(sentenceText);

                if(sentenceText.length>0)
                    answerList.push(sentenceText);
            }
        }
    }
    else if('snippet' in answer){
        // snippet format: Eg: ChallengerMode
        let snippet = answer['snippet'];
        let entities = await googleNlpEntityExtraction(snippet);

        // console.log(entities);
        for(let i=0; !isNullOrUndefined(entities) && i<entities.length; i++){
            if(entities[i]['type'] && entities[i]['type'].toLowerCase()=='organization'){
                //It is an organization
                let mentions = entities[i]["mentions"];
                if(!isNullOrUndefined(mentions)){
                    let isProper = false;
                    let mentionText = null;
                    for(let j=0; j<mentions.length; j++){
                        if(mentions[j].type.toLowerCase()=="proper"){
                            isProper = true;
                            mentionText = mentions[j].text;
                            break;
                        }
                    }
                    // console.log(mentions,isProper);
                    if(isProper){
                        //Proper noun
                        let companyWords = getCompanyWords(company); 
                        let companySubstrings = createLinearSubstringsForCompany(companyWords);

                        let isUniqueWord = true;
                        for(let j=0; !isNullOrUndefined(companySubstrings) && j<companySubstrings.length; j++){
                            if(mentionText.toLowerCase().includes(companySubstrings[j].toLowerCase())){
                                isUniqueWord = false;
                            }
                        }
                        if(isUniqueWord){
                            answerList.push(mentionText);
                        }
                    }
                }
            }
        }
        
    }
    if(answerList.length>0){
        output = { 'list': answerList, 'data': answerList.join(", "),'link': link};
    }

    // get answer
    return output;
}

export const googleNlpIconBulletExtraction = async(text) => {
    if(isNullOrUndefined(text) || text.trim().length==0)
        return {"entities": [], "verbList": []};
    
    let entityPromise = googleNlpEntityExtraction(text);
    let syntaxPromise = googleNlpSyntaxExtraction(text);
    let allPromises = [entityPromise,syntaxPromise];

    let results = await Promise.all(allPromises);

    let entities = results[0];
    let syntaxes = results[1];
    // console.log(entities,syntaxes)

    let lemmaMap = {};
    let verbList = [];

    let verbCnt = 0;
    for(let i=0; i<syntaxes.length; i++){
        if(syntaxes[i].text && syntaxes[i].lemma && (syntaxes[i].text != syntaxes[i].lemma)){
            lemmaMap[syntaxes[i].text] = syntaxes[i].lemma
        }
        if(syntaxes[i]["part_of_speech"] && syntaxes[i]["part_of_speech"]=="VERB" && syntaxes[i]['lemma']){
            if(verbCnt < Const.verbLen){
                verbList.push({
                    "name": syntaxes[i]['lemma'],
                    "salience": 0.5
                });
                verbCnt++;
            }
        }
    }
    // console.log(lemmaMap);

    for(let i=0; i<entities.length; i++){
        if(entities[i].name && entities[i].name in lemmaMap){
            entities[i].name = lemmaMap[entities[i].name];
        }
        let mentions = entities[i].mentions
        for(let j=0; !isNullOrUndefined(mentions) && j<mentions.length; j++){
            if(mentions[j].text && mentions[j].text in lemmaMap){
                entities[i].mentions[j].text = lemmaMap[entities[i].mentions[j].text]
            }
        }
    }
    // console.log(entities);
    // console.log(verbList);

    return {"entities": entities, "verbList": verbList};
}

export const googleNlpEntityExtraction = async(text) => {
    const endpoint = 'https://us-central1-flowpro-9e1c6.cloudfunctions.net/entityExtraction';
    let output = {};
    // console.log(endpoint);
    // console.log(searchQuery);

    let res = await fetch(endpoint, 
        { 
            method: 'POST', 
            body: JSON.stringify({'text':text}),
            headers: new Headers({'content-type': 'application/json'})
        }
    ).catch((err)=>{console.log(err)}); 

    if(!isNullOrUndefined(res)){
        let resJson = await res.json();
        output = resJson;        
        // console.log(output);    
    }
    return output
}

export const googleNlpSyntaxExtraction = async(text) => {
    const endpoint = 'https://us-central1-flowpro-9e1c6.cloudfunctions.net/syntaxExtraction';
    let output = {};
    // console.log(endpoint);
    // console.log(searchQuery);

    let res = await fetch(endpoint, 
        { 
            method: 'POST', 
            body: JSON.stringify({'text':text}),
            headers: new Headers({'content-type': 'application/json'})
        }
    ).catch((err)=>{console.log(err)}); 

    if(!isNullOrUndefined(res)){
        let resJson = await res.json();
        output = resJson;        
        // console.log(output);    
    }
    return output
}

export const getIndustryCyberNewsArrFromBuckets = (industryMap) => {
    if(isNullOrUndefined(industryMap))
        return [];
    let output = [];
    for(let key in industryMap){
        let currArr = industryMap[key]['cyberIncidents'];
        output = output.concat(currArr);
    }
    output = Utils.dedupArrayOnKey(output,'link');
    return output;
}

export const getKeyWords = (filterArr, keyWordsMap) => {
    let isAll = false;
    if(isNullOrUndefined(filterArr) || filterArr.length==0)
    {
        isAll = true
    }

    // console.log(filterArr)
    // console.log(keyWordsMap);
    let keyWords = {};
    if(!isNullOrUndefined(keyWordsMap)){
        for(var category in keyWordsMap){
            // console.log(category);
            if(filterArr.includes(category) || isAll){
                let currKeyWords = keyWordsMap[category];
                for(let i=0; i<currKeyWords.length; i++){
                    keyWords[currKeyWords[i]] = '';
                }
            }
        }
    }
    // console.log(keyWords);
    let finalKeyWords = [];
    for(var keyWord in keyWords){
        finalKeyWords.push(keyWord);
    }
    // console.log(finalKeyWords);
    return finalKeyWords;
}

export const sortBasedOnDate = (arr, dateKey) => {
    if(isNullOrUndefined(arr) || isNullOrUndefined(dateKey))
        return arr;
    
    let nowTs = Date.now();
    for(let i=0; i<arr.length; i++){
        let dateStr = arr[i][dateKey];
        let dateVal = Date.parse(dateStr);
        if(dateVal == NaN)
            arr[i]['ts_date'] = -1;
        else
            arr[i]['ts_date'] = Math.abs(nowTs - dateVal);
    }

    arr.sort((a,b) => {
        return a.ts_date - b.ts_date
    });

    return arr;
}

export const cyberNewsArticlesRenderFilter = (arr, keyWords, topLimit) => {

    if(isNullOrUndefined(arr) || isNullOrUndefined(keyWords))
        return [];
    if(isNullOrUndefined(topLimit)){
        topLimit = arr.length+1;
    }

    // console.log(arr);
    let keyWordsArr = [];
    for(let i=0; i<keyWords.length; i++){
        keyWordsArr.push({
            'text': keyWords[i],
            'score': 1
        });
    }

    let existingDates = []; //{ts, dateStr}
    let finalArr = [];
    let dateStrLists = {};
    //buckets
    for(let i=0; i<arr.length; i++){
        let dateStr = arr[i].date;
        let dateVal = Date.parse(dateStr);

        if(!isNaN(dateVal)){
            for(let j=0; j<existingDates.length; j++){
                if(Math.abs(existingDates[j].ts-dateVal)<=3*Day){
                    dateStr = existingDates[j].dateStr;
                    break;
                }
            }
        }
        else{
            dateVal = Date.now();
        }
        let title = arr[i].title;
        if(isNullOrUndefined(title))
            title = "";
        
        let score = getScore(title,keyWordsArr);

        if(!(dateStr in dateStrLists) || score > dateStrLists[dateStr].score){
            dateStrLists[dateStr] = {'val':arr[i],'score':score, 'ts': dateVal};
        }
        
    }
    // console.log(dateStrLists);

    for(let key in dateStrLists){
        finalArr.push(dateStrLists[key]);
    }
    finalArr.sort((a,b) => {
        if(a.score == b.score){
            return b.ts - a.ts;
        }
        return b.score - a.score
    });

    //Rank scoring
    for(let i=0; i<finalArr.length; i++){
        finalArr[i].score = getScore(finalArr[i].val.title, keyWordsArr, true);
    }
    finalArr.sort((a,b) => {
        if(a.score == b.score){
            return b.ts - a.ts;
        }
        return b.score - a.score
    });
    // console.log(finalArr);

    let output = [];
    for(let i=0; i<finalArr.length && i<topLimit; i++){
        if(finalArr[i].score>0)
            output.push(finalArr[i].val);
    }

    return output;
}

export const getScore = (str, keyWords, isWeighted) => {
    let score = 0;
    for(let i=0; i<keyWords.length; i++){
        if(str.toLowerCase().includes(keyWords[i].text.toLowerCase())){
            score = score + keyWords[i].score;       
            if(isWeighted){
                keyWords[i].score /= 2;
            }
        }
    }
    return score;
}


export const getWebsiteBuiltWithDataFromDb = async(website) => {

    try{
        if(isNullOrUndefined(website))
            return;

        website = website.trim();
        let websiteHash = Utils.getShaKey(website);

        let docRef = firebase.firestore().collection('Data').doc('techStack').collection('builtWith').doc(websiteHash);
        let doc = await docRef.get();
        if(doc.exists){
            let data = doc.data();
            let ts = data['ts'];
            if(isNullOrUndefined(ts) || Math.abs(ts - Date.now())>300*Day){
                docRef.delete();
                return null;
            }
            let finalData = {};
            finalData['techList'] = data['techList']
            if(!isNullOrUndefined(finalData['techList']))
                return finalData;
        }
    }
    catch(e){
        return null;
    }

    return null;
}

export const getWebsiteBuiltWithDataFromApi = async(url) => {
    const endpoint = 'https://us-central1-flowpro-9e1c6.cloudfunctions.net/scrapeBuiltWithTechStackData';
    let output = {};
    // console.log(endpoint);
    // console.log(searchQuery);
    url = url.trim()
    console.log(url)

    let res = await fetch(endpoint, 
        { 
            method: 'POST', 
            body: JSON.stringify({'url':url}),
            headers: new Headers({'content-type': 'application/json'})
        }
    ).catch((err)=>{console.log(err)}); 

    if(!isNullOrUndefined(res)){
        let resJson = await res.json();
        output = resJson;        
        // console.log(output);    
    }
    
    return output
}

export const saveWebsiteBuiltWithDataToDb = async(website, data) => {

    try{
        //data has 'techList'
        if(isNullOrUndefined(website) || isNullOrUndefined(data) || !('techList' in data))
            return;

        website = website.trim();
        let websiteHash = Utils.getShaKey(website);

        let docRef = firebase.firestore().collection('Data').doc('techStack').collection('builtWith').doc(websiteHash);
        
        data['websiteUrl'] = website;
        data['ts'] = Date.now();

        await docRef.set(data);
    }catch(e){

    }
}

export const getTechStackListBasedOnKeyWord = (list, keyWord) => {


    list.sort(function(a, b) { 
        if(isNullOrUndefined(a['Name']))
            return -1;
        if(isNullOrUndefined(b['Name']))
            return 1;
        if ( a['Name'] < b['Name'] ){
        return -1;
        }
        if ( a['Name'] > b['Name'] ){
            return 1;
        }
        return 0;
    })

    if(isNullOrUndefined(list))
        return [];
    if(isNullOrUndefined(keyWord) || keyWord.trim()==''){
        return list;
    }

    let finalList = [];
    keyWord = keyWord.toLowerCase();
    for(let i=0; i<list.length; i++){
        let canAdd = false;
        let element = list[i]
        if('Name' in element && element['Name'].toLowerCase().includes(keyWord)){
            canAdd = true;
        }
        if('Tag' in element && element['Tag'].toLowerCase().includes(keyWord)){
            canAdd = true;
        }
        if('Description' in element && 
            element['Description'].toLowerCase().includes(keyWord)){
            canAdd = true;
        }
        if('Categories' in element){
            let categories = element['Categories'];
            for(let j=0; j<categories.length; j++){
                if(categories[j].toLowerCase().includes(keyWord))
                {
                    canAdd = true;
                    break;
                }
            }
        }

        if(canAdd){
            finalList.push(element);
        }
    }
    return finalList;
}

export const scrapeSingleUrl = async(url, keyWords) => {
    if(isNullOrUndefined(url) || url.trim()=="")
        return [];
    let bodyJson = {'url': url}
    if(!isNullOrUndefined(keyWords))
        bodyJson['wordList']=keyWords;

    let output = [];
    const endpoint = 'https://us-central1-flowpro-9e1c6.cloudfunctions.net/webParaScraperWithTextFilter';
    let res = await fetch(endpoint, 
        { 
            method: 'POST', 
            body: JSON.stringify(bodyJson),
            headers: new Headers({'content-type': 'application/json'})
        }
    ).catch((err)=>{console.log(err)}); 

    if(!isNullOrUndefined(res)){
        let resJson = await res.json();
        output = resJson;
    }
    
    DbUtils.writeWebscraperOutputToDb(url, output);

    return output;
}

export const getNewsArticleSummary = async(url, keyWords) => {
    //get paragraphs
    // console.log(url);
    let scrapedParas = await scrapeSingleUrl(url, keyWords);
    // console.log(scrapedParas);

    let fullText = "";
    for(let i=0; !isNullOrUndefined(scrapedParas) && i<scrapedParas.length; i++){
        if(scrapedParas[i].score){
            fullText += scrapedParas[i].text.trim();
            fullText += " "
        }
    }

    // console.log(fullText);

    if(fullText.trim()=="")
        return [];

    //get summary text here.
    let output = [];
    try{
        var textRankSummary = firebase.functions().httpsCallable('textRankSummary');
        let res = await textRankSummary({ 'text': fullText, 'numOfSentences':4});
        if(res.data && res.data.result){
            output = res.data.result;
        }
        // let res = await textRankSummary({ 'firstName': "Shashank", 'lastName': "Anantharam"});
        // console.log(res);
    }catch (e) {
        console.log(e);
    }

    return output;
}

export const pointsVerbAlgo = (verbList) => {
    if(isNullOrUndefined(verbList) || verbList.length==0)
        return [];

    // console.log(verbList);

    let finalList = [];

    for(let i=0; i<verbList.length; i++){
        if(!(verbList[i].name in Const.commonVerbs)){
            finalList.push(verbList[i]);
        }
    }
    return finalList;
}

export const pointsEntityAlgo = (pointEntities) => {
    if(isNullOrUndefined(pointEntities))
        return [];

    let entityList = [];
    let prevEntities = {};
    // console.log(pointEntities);
    let len = pointEntities.length;
    let limit = Math.max(len/3,Const.entityCommonLen);
    let properNoun_limit = Math.max(len/3,Const.entityCommonLen);
    let currentCommonEntities = 0;
    let currentProperEntities = 0;

    let tempPointEntityArr = [];
    let iS = 0, iE = len-1, flag=false;
    while(iS<=iE){
        let iCurr = iS;
        if(flag)
            iCurr = iE;
        tempPointEntityArr.push(pointEntities[iCurr]);
        if(flag)
            iE--;
        else
            iS++;
        flag = !flag;
    }
    pointEntities = tempPointEntityArr;

    // console.log(pointEntities);

    for(let i=0; i<len; i++){
        let currEntity = pointEntities[i];
        if(currEntity.mentions){
            for(let j=currEntity.mentions.length-1; j>=0; j--){

                //This part remains similar in any algorithm (iterate over sentences)
                let shouldAdd = false;
             
                if(currEntity.mentions[j].type == "PROPER" && currentProperEntities<properNoun_limit)
                    shouldAdd = true;   
                if(currEntity.mentions[j].type == "COMMON" && currentCommonEntities<limit){
                    shouldAdd = true;
                }
                if(!(currEntity.mentions[j].text.trim() in prevEntities) && shouldAdd)
                {
                    let wordSplit = currEntity.mentions[j].text.trim().split(" ");
                    if(currEntity.mentions[j].type == "COMMON" && 
                    (wordSplit.length>1 && (wordSplit[1]!="and" && wordSplit[1]!="&"))){
                        //multiple words same line
                            for(let k=0; k<wordSplit.length; k++){
                                let currWord = wordSplit[k].trim();
                                if(currWord.length>0 && !(currWord in prevEntities)){
                                    entityList.push({
                                        name: currWord,
                                        salience: currEntity["salience"]
                                    });
                                    prevEntities[currWord] = "";
                                    currentCommonEntities++;
                                }
                            }
                    }
                    else
                    {
                        entityList.push({
                            name: currEntity.mentions[j].text.trim(),
                            salience: currEntity["salience"]
                        });
                        prevEntities[currEntity.mentions[j].text.trim()] = "";

                        if(currEntity.mentions[j].type == "COMMON"){
                            currentCommonEntities++;
                        }
                        else if(currEntity.mentions[j].type == "PROPER"){
                            currentProperEntities++;
                        }
                    }
                }                 
            }
        }
    }
    // console.log(entityList);
    return entityList;
}

export const searchIconsFromKeywords = async(query) => {
    if(isNullOrUndefined(query) || query.trim()=="")
        return [];

    // console.log(query)
    let dbOutput = await DbUtils.getIconApiCallFromDb(query, "iconfinder");
    if(!isNullOrUndefined(dbOutput) && dbOutput.length>0){
        // console.log('read from db')
        return dbOutput;
    }


    let bodyJson = {'query': query}

    let output = [];
    const endpoint = 'https://us-central1-flowpro-9e1c6.cloudfunctions.net/iconfinderApiSearch';
    let res = await fetch(endpoint, 
        { 
            method: 'POST', 
            body: JSON.stringify(bodyJson),
            headers: new Headers({'content-type': 'application/json'})
        }
    ).catch((err)=>{console.log(err)}); 

    // console.log(res);
    if(!isNullOrUndefined(res)){
        let resJson = await res.json();
        if('iconList' in resJson)
            output = resJson['iconList'];
    }
    // console.log(output);

    //Save to firebase, due to low searches allowed
    if(!isNullOrUndefined(output) && output.length>0){
        DbUtils.writeIconApiCallToDb(query, "iconfinder", output);
    }

    return output;
}


export const searchNounProjectIconsFromKeywords = async(query) => {
    if(isNullOrUndefined(query) || query.trim()=="")
        return [];

    // console.log(query)
    //READ from Firebase if query already exists
    let dbOutput = await DbUtils.getIconApiCallFromDb(query, "nounproj");
    if(!isNullOrUndefined(dbOutput) && dbOutput.length>0){
        // console.log('read from db')
        return dbOutput;
    }

    let bodyJson = {'query': query}

    let output = [];
    const endpoint = 'https://us-central1-flowpro-9e1c6.cloudfunctions.net/nounProjectApiSearch';
    let res = await fetch(endpoint, 
        { 
            method: 'POST', 
            body: JSON.stringify(bodyJson),
            headers: new Headers({'content-type': 'application/json'})
        }
    ).catch((err)=>{console.log(err)}); 

    // console.log(res);
    if(!isNullOrUndefined(res)){
        let resJson = await res.json();
        if('iconList' in resJson)
            output = resJson['iconList'];
    }
    // console.log(output);

    //Save to firebase, due to low searches allowed
    if(!isNullOrUndefined(output) && output.length>0){
        DbUtils.writeIconApiCallToDb(query, "nounproj", output);
    }

    return output;
}


export const downloadIconfinderIcon = async(url) => {
    if(isNullOrUndefined(url) || url.trim()=="")
        return [];
    let bodyJson = {'url': url}

    let output = [];
    const endpoint = 'https://us-central1-flowpro-9e1c6.cloudfunctions.net/iconFinderImageDownload';
    let res = await fetch(endpoint, 
        { 
            method: 'POST', 
            body: JSON.stringify(bodyJson),
            headers: new Headers({'content-type': 'application/json'})
        }
    ).catch((err)=>{console.log(err)}); 

    // console.log(res);
    if(!isNullOrUndefined(res)){
        let resJson = await res.json();
        if('value' in resJson)
            output = resJson['value'];
    }
    // console.log(output);

    return output;
}


export const getWordSynonyms = async(word) => {
    if(isNullOrUndefined(word) || word.trim()=="")
        return [];
    let bodyJson = {'word': word}

    let output = [];
    const endpoint = 'https://us-central1-flowpro-9e1c6.cloudfunctions.net/getWordSynonym';
    let res = await fetch(endpoint, 
        { 
            method: 'POST', 
            body: JSON.stringify(bodyJson),
            headers: new Headers({'content-type': 'application/json'})
        }
    ).catch((err)=>{console.log(err)}); 

    // console.log(res);
    if(!isNullOrUndefined(res)){
        let resJson = await res.json();
        // console.log(resJson);
        if(!isNullOrUndefined(resJson) && resJson!="{}" && 'synonyms' in resJson)
            output = resJson['synonyms'];
    }
    // console.log(output);

    return output;
}